import { Actions as ACTIONS } from '@/redux/actions/companyActions';
import { CheckCircleIcon, XMarkIcon } from "@heroicons/react/20/solid";
import { NotificationManager } from 'react-notifications';
import { connect } from 'react-redux';
import AdvancedAllowance from "../allowance-tab/AdvancedAllowance";
import AdvancedOvertime from "../overtime-tab/AdvancedOvertime";

const AdvancedSettingsModal = ({
    modalStatus,
    closeModal,
    type,
}) => {

    const AdvancedFields = () => {
        switch (type) {
            case 'Overtime': return <AdvancedOvertime />
            case 'Pay Item':
            case 'Allowance':
            return <AdvancedAllowance />
        }
    }

    if (!modalStatus) return null
    return (
        <div className="modal" tabIndex="-1" role="dialog" aria-hidden="true" style={{ display: "block", background: "rgba(0,0,0,0.4)", overflow: "auto" }}>
            <div className="modal-dialog" style={{ width: "60%" }}>
                <div className="modal-content">
                    <div className="block block-themed block-transparent remove-margin-b" style={{ padding: 0 }}>
                        <div className="block-header bg-primary-dark" style={{ padding: 20, position: 'sticky', top: 0, zIndex: 50 }}>
                            <ul className="block-options">
                                <li>
                                    <button type="button" onClick={closeModal}>
                                        <XMarkIcon className="h-6 w-6 mr-3 text-white" />
                                    </button>
                                </li>
                            </ul>
                            <h3 className="block-title">{type ? type : 'Advanced'} Settings</h3>
                        </div>

                        <div className="block-content" style={{ margin: 20 }}>
                            <AdvancedFields />
                            <div className="clearfix"></div>
                        </div>
                        <div className="btn btn-default pull-right" style={{ margin: 20 }} onClick={()=>{
                                            closeModal()
                                            NotificationManager.info('Save your settings to permanently save your allowance update', 'You have unsaved settings')
                                        }}>
                            <CheckCircleIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
                            <div style={{ float: "left" }}>Confirm</div>
                        </div>
                        <div className="clearfix"></div>
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state, ownProps) => {

    return {
        modalStatus: state.company?.advancedSettingsModal ? true : false,
        type: state.company?.advancedSettingsModal?.type
    }
}
const mapDispatchToProps = dispatch => ({
    closeModal: () => dispatch(ACTIONS.advancedSettingsModal()),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AdvancedSettingsModal) 
